import * as React from 'react'

import { cn } from '~/styled'
import { ToggleGroup } from '~/utilities/radix-overrides/toggle-group'

type TTileToggleGroupRootProps = React.ComponentProps<typeof ToggleGroup.Root>

export const TileToggleGroupRoot = React.forwardRef<
  HTMLDivElement,
  TTileToggleGroupRootProps
>(({ orientation, className, ...rest }, ref) => (
  <ToggleGroup.Root
    ref={ref}
    {...rest}
    className={cn(
      'flex',
      'gap-2',
      orientation === 'horizontal' && 'flex-row',
      orientation === 'vertical' && 'flex-col',
      'flex-wrap',
      className
    )}
  />
))
